export default __webpack_public_path__ + "src/images/packages/villa-one-hilltop/a44daa68d7575dc2beb4fa01127ffb4e-5.jpg";